import { useCallback } from "react";
import { useNewton } from "../store/NewtonContext";

/**
 * Hook to export chat session as JSON
 * Usage: const exportSession = useExportSession();
 * exportSession({ sessionId, userId, messages, displayName })
 */
export function useExportSession() {
  const { llmEnv } = useNewton();

  const exportSession = useCallback(
    ({ sessionId, userId, messages = [], displayName = "" }) => {
      try {
        const exportData = {
          sessionId: sessionId || "unknown",
          userId: userId || "unknown",
          displayName: displayName || `Chat ${sessionId?.slice(-6) || ""}`,
          exportedAt: new Date().toISOString(),
          environment: llmEnv || "prod",
          messages: messages.map((msg) => ({
            from: msg.from || "unknown",
            message: msg.message || "",
            timestamp: msg.timestamp || Date.now(),
            attachedFilesLength: msg.attachedFilesLength || 0,
          })),
        };

        const jsonString = JSON.stringify(exportData, null, 2);
        const blob = new Blob([jsonString], { type: "application/json" });
        const url = URL.createObjectURL(blob);

        const timestamp = new Date().toISOString().replace(/[:.]/g, "-");
        const filename = `chat-session-${sessionId || "unknown"}-${timestamp}.json`;

        const link = document.createElement("a");
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      } catch (error) {
        console.error("Failed to export session:", error);
        throw error;
      }
    },
    [llmEnv]
  );

  return exportSession;
}

